<script>

import CampaignCartItem from "@/helpers/cart/CampaignCartItem";

export default {
  props: {
    campaignCartItem: {
      type: CampaignCartItem,
      required: true,
    },
  },
  computed: {
    totalInfluencerCount() {
      return Object.keys(this.campaignCartItem.influencerCartItems).length
    },
    totalNetworksCount() {
      const socialNetworks = new Set();
      // eslint-disable-next-line no-unused-vars
      for (let [influencerId, influencerCartItem] of Object.entries(this.campaignCartItem.influencerCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {
          for (let pricePackageItem of pricePackageCartItem.pricePackage.price_package_items) {
            if(pricePackageItem.social_network) {
              socialNetworks.add(pricePackageItem.social_network)
            }
          }
        }
      }

      return socialNetworks.size
    },
    totalReach() {

      let totalReach = 0;

      // eslint-disable-next-line no-unused-vars
      for (let [influencerId, influencerCartItem] of Object.entries(this.campaignCartItem.influencerCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {

          let pricePackageItemsReach = 0
          for (let pricePackageItem of pricePackageCartItem.pricePackage.price_package_items) {

            const socialNetwork = pricePackageItem.social_network;
            const socialNetworkAccount = influencerCartItem.socialNetworkAccounts[socialNetwork]
            if (socialNetworkAccount) {
              let reach = socialNetworkAccount.last_30_days_avg_reach_per_post ?? socialNetworkAccount.last_30_days_new_users ?? 0;
              pricePackageItemsReach += (reach * pricePackageItem.quantity);
            }
          }

          totalReach += (pricePackageItemsReach * pricePackageCartItem.amount)
        }
      }

      return totalReach;
    },
    totalPrice() {
      let totalPrice = 0;

      // eslint-disable-next-line no-unused-vars
      for (let [influencerId, influencerCartItem] of Object.entries(this.campaignCartItem.influencerCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {
          if (pricePackageCartItem.pricePackage.total_gross_price) {
            totalPrice += pricePackageCartItem.pricePackage.total_gross_price * pricePackageCartItem.amount;
          }
        }
      }

      return totalPrice;
    },
    totalCpm() {
      const totalReach = this.totalReach;
      if (!totalReach) {
        return 0
      }
      return Math.round((1000 / totalReach) * this.totalPrice)
    },
    totalPosts() {
      let totalPosts = 0;

      // eslint-disable-next-line no-unused-vars
      for (let [influencerId, influencerCartItem] of Object.entries(this.campaignCartItem.influencerCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {

          let pricePackagePostsCount = 0
          for (let pricePackageItem of pricePackageCartItem.pricePackage.price_package_items) {
            pricePackagePostsCount += pricePackageItem.quantity;
          }

          totalPosts += (pricePackagePostsCount * pricePackageCartItem.amount)
        }
      }

      return totalPosts;
    },
  },
  data() {
    return {
      showInfluencers: true
    }
  }
}
</script>

<template>
  <div>
    <div class="row">
      <div class=" col-6 col-md-4 col-lg-2 mt-2 mt-lg-0">
        <div class="row text-right">
          <div class="col-12 mb-0 mb-xl-1 font-size-13 text-muted">
            Influencers
          </div>
          <div class="col-12 h-100">
            <h5 class="mb-0">{{ totalInfluencerCount }}</h5>
          </div>
        </div>
      </div>
      <div class=" col-6 col-md-4 col-lg-2 mt-2 mt-lg-0">
        <div class="row text-right">
          <div class="col-12 mb-0 mb-xl-1 font-size-13 text-muted">
            Networks
          </div>
          <div class="col-12 h-100">
            <h5 class="mb-0">{{ totalNetworksCount }}</h5>
          </div>
        </div>
      </div>
      <div class=" col-6 col-md-4 col-lg-2 mt-2 mt-lg-0">
        <div class="row text-right">
          <div class="col-12 mb-0 mb-xl-1 font-size-13 text-muted">
            Posts
          </div>
          <div class="col-12 h-100">
            <h5 v-if="totalPosts" class="mb-0">{{ totalPosts }}</h5>
            <h5 v-else class="mb-0">N/A</h5>
          </div>
        </div>
      </div>
      <div class=" col-6 col-md-4 col-lg-2 mt-2 mt-lg-0">
        <div class="row text-right">
          <div class="col-12 mb-0 mb-xl-1 font-size-13 text-muted">
            Reach
          </div>
          <div class="col-12 h-100">
            <h5 v-if="totalReach" class="mb-0">{{ totalReach.toLocaleString() }}</h5>
            <h5 v-else class="mb-0">N/A</h5>
          </div>
        </div>
      </div>
      <div class=" col-6 col-md-4 col-lg-2 mt-2 mt-lg-0">
        <div class="row text-right">
          <div class="col-12 mb-0 mb-xl-1 font-size-13 text-muted">
            CPM
          </div>
          <div class="col-12 h-100">
            <h5 v-if="totalCpm" class="mb-0">&euro;{{ totalCpm.toLocaleString() }}</h5>
            <h5 v-else class="mb-0">N/A</h5>
          </div>
        </div>
      </div>
      <div class=" col-6 col-md-4 col-lg-2 mt-2 mt-lg-0">
        <div class="row text-right">
          <div class="col-12 mb-0 mb-xl-1 font-size-13 text-muted">
            Price
          </div>
          <div class="col-12 h-100">
            <h5 v-if="totalPrice" class="mb-0">&euro;{{ totalPrice.toLocaleString() }}</h5>
            <h5 v-else class="mb-0">N/A</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
